export default function(e) {
    var form = e.querySelectorAll('input, select, button, textarea')
    var formData = {}
    for (var i = 0; i < form.length; i++) {
        var element = form[i];
        
        if(element.name) {
            formData[element.name] = element.value
        }
    }

    return formData
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/serialize.js